
import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./FileViewer.css";

// ⚙️ Configuration du worker PDF.js
// pdfjs.GlobalWorkerOptions.workerSrc =
//   "https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js";


pdfjs.GlobalWorkerOptions.workerSrc =
  "https://unpkg.com/pdfjs-dist@2.9.359/build/pdf.worker.min.js";

const FileViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");
  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileUrl);

  useEffect(() => {
    // Reset état à chaque nouveau fichier
    setNumPages(0);
    setLoading(true);
    setError(null);
  }, [fileUrl]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (err) => {
    setError("Erreur de chargement du PDF : " + err.message);
    setLoading(false);
  };

  return (
    <div
      className="file-viewer-container"
      style={{
        textAlign: "center",
        padding: "10px",
        backgroundColor: "#fafafa",
        borderRadius: "8px",
        minHeight: "50vh",
      }}
    >
      {loading && <p style={{ color: "#888" }}>Chargement du document...</p>}

      {/* 📄 PDF */}
      {isPDF && !error && (
        <Document
          file={fileUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={<p>Chargement du PDF...</p>}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              width={600} // Ajustable selon la taille souhaitée
            />
          ))}
        </Document>
      )}

      {/* 🖼️ Image */}
      {isImage && !error && (
        <img
          src={fileUrl}
          alt="Aperçu du fichier"
          style={{
            maxWidth: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError("Impossible d'afficher l'image.");
            setLoading(false);
          }}
        />
      )}

      {/* ❌ Erreur */}
      {error && (
        <p style={{ color: "red", marginTop: "10px" }}>
          {typeof error === "string" ? error : error.message}
        </p>
      )}

      {/* ⚠️ Format non supporté */}
      {!isPDF && !isImage && !error && !loading && (
        <p>Format de fichier non pris en charge.</p>
      )}
    </div>
  );
};

export default FileViewer;
